/*
 * nd-echeance.js — compte à rebours jusqu'à une échéance (Neurodidacte)
 * --------------------------------------------------------------------
 * Contrat : un élément [data-nd-echeance="2026-09-30T23:59:59-04:00"] (ISO 8601
 * AVEC décalage : la même heure de Montréal pour tout le monde, quel que soit le
 * fuseau du visiteur) contenant [data-nd-j] [data-nd-h] [data-nd-m] [data-nd-s].
 * Facultatif : data-nd-echeance-fin="Message" — remplace, une fois l'échéance
 * passée, le texte de l'élément [data-nd-echeance-message] de la même section.
 *
 * Les chiffres sont masqués (visibility) tant que ce script n'a pas tourné : on
 * n'affiche jamais « 0 jour » par défaut. La classe `is-ready` les révèle.
 * L'élément est aria-hidden : l'échéance est écrite en toutes lettres à côté, et
 * un décompte qui change chaque seconde n'a rien à faire dans un lecteur d'écran.
 * Premier usage : sections/nd-hero-offre.liquid (offre de la rentrée 2026).
 */
(function () {
  'use strict';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function init(root) {
    if (root.dataset.ndEcheanceBound === 'true') return;
    var cible = Date.parse(root.dataset.ndEcheance);
    if (isNaN(cible)) return; // date illisible : les cases restent invisibles
    root.dataset.ndEcheanceBound = 'true';

    var j = root.querySelector('[data-nd-j]');
    var h = root.querySelector('[data-nd-h]');
    var m = root.querySelector('[data-nd-m]');
    var s = root.querySelector('[data-nd-s]');
    var timer = null;

    function fin() {
      root.hidden = true;
      var texte = root.dataset.ndEcheanceFin;
      var section = root.closest('.shopify-section') || root.parentNode;
      var message = section && section.querySelector('[data-nd-echeance-message]');
      if (texte && message) message.textContent = texte;
      if (timer) clearInterval(timer);
    }

    function tick() {
      var reste = cible - Date.now();
      if (reste <= 0) return fin();
      if (j) j.textContent = Math.floor(reste / 86400000);
      if (h) h.textContent = pad(Math.floor((reste % 86400000) / 3600000));
      if (m) m.textContent = pad(Math.floor((reste % 3600000) / 60000));
      if (s) s.textContent = pad(Math.floor((reste % 60000) / 1000));
    }

    tick();
    if (!root.hidden) {
      root.classList.add('is-ready');
      timer = setInterval(tick, 1000);
    }
  }

  function boot() {
    document.querySelectorAll('[data-nd-echeance]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
